import { Heading } from 'blaze-ui/Heading/Heading'
import Styles from './Cta.module.scss'

import { Modal } from 'almanac-ui/Modal'
import { Button } from 'blaze-ui/Button'
import { ColumnVertical1, Send1, Target2, TemplatesFilled, UsersProfiles1 } from 'blaze-ui/icons'
import Server02 from 'blaze-ui/icons/16/Server02'

export const Cta = ({
  onCancel,
  onConfirm,
  isTrialing,
  onUpgradeToGrowth,
}: {
  onCancel: () => void
  onConfirm: () => void
  isTrialing: boolean
  onUpgradeToGrowth: () => void
}) => {
  return (
    <Modal.Content className={Styles.modalContent}>
      <div className={Styles.container}>
        <div className={Styles.leftSection}>
          <div className={Styles.contentWrapper}>
            <div className={Styles.content}>
              <Heading level={1}>Upgrade to Growth to unlock full access</Heading>
              <div className={Styles.features}>
                <Heading level={5}>Upgrade and unlock:</Heading>
                <div className={Styles.feature}>
                  <Send1 color="var(--blue-50)" />
                  <Heading level={4}>Unlimited posting & cross-posting</Heading>
                </div>
                <div className={Styles.feature}>
                  <TemplatesFilled color="var(--blue-50)" />
                  <Heading level={4}>Unlimited posting channels</Heading>
                </div>
                <div className={Styles.feature}>
                  <UsersProfiles1 color="var(--blue-50)" />
                  <Heading level={4}>Unlimited seats and multi-user workflow</Heading>
                </div>
                <div className={Styles.feature}>
                  <ColumnVertical1 color="var(--blue-50)" />
                  <Heading level={4}>Parallel campaigns</Heading>
                </div>
                <div className={Styles.feature}>
                  <Target2 color="var(--blue-50)" />
                  <Heading level={4}>AI ad management</Heading>
                </div>
                <div className={Styles.feature}>
                  <Server02 size={19} color="var(--blue-50)" />
                  <Heading level={4}>2000 generation credits</Heading>
                </div>
              </div>
            </div>
          </div>
          <div className={Styles.footer}>
            <Button variant="tertiary" onPress={onCancel}>
              Close
            </Button>
            <div className={Styles.right}>
              <Button variant="tertiary" onPress={onConfirm}>
                See All Plans
              </Button>
              <Button onPress={onUpgradeToGrowth}>Upgrade to Growth</Button>
            </div>
          </div>
        </div>
        <div className={Styles.rightSection}></div>
      </div>
    </Modal.Content>
  )
}
